import React, { useState } from 'react';
import Timer from './Sub-Components/Timer';
import CardRow from './Sub-Components/CardList';
import CardInfo from './Sub-Components/CardInfo';
import ButtonGroup from './Sub-Components/TopButton';
import Rules from './Sub-Components/Rules';
import Mode from './Sub-Components/Mode';
import './Game.css';

const Game = () => {
  const [activeButton, setActiveButton] = useState(1);
  const [removeCard, setRemoveCard] = useState([]);
  const [prevTime, setPrevTime] = useState(45 * 60); // 30 mins
  const [gamemode, setGameMode] = useState(0); 
  const [showGameModal, setGameModal] = useState(true);
  const [showInfoPopup, setShowInfoPopup] = useState(false);

  return (
    <div className='my-container'>
      <Mode setGameMode={setGameMode} showGameModal={showGameModal} setGameModal={setGameModal}  />

      {gamemode !== 0 && (
          <div>
            <Timer gamemode={gamemode} prevTime={prevTime} setPrevTime={setPrevTime} setActiveButton={setActiveButton} activeButton={activeButton} showInfoPopup={showInfoPopup} setShowInfoPopup={setShowInfoPopup}  />
            <ButtonGroup setActiveButton={setActiveButton} activeButton={activeButton} />
            <Rules />
            <div className="card-list">
              {activeButton === 1 ? (
                <CardRow
                  removeCard={removeCard}
                  setRemoveCard={setRemoveCard}
                  prevTime={prevTime}
                  setPrevTime={setPrevTime}
                />
              ) : (
                <CardInfo showInfoPopup={showInfoPopup} setShowInfoPopup={setShowInfoPopup}/>
              )}
            </div>
          </div>
        )}



    </div>
  );
};

export default Game;
